import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import AnimatedImage from "../../components/AnimatedImage";
import SeoHead from "../../components/SeoHead";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { ArrowUpRight } from "lucide-react";

export default function Programs() {
    const { config } = useSiteConfig();
    const [programs, setPrograms] = useState([]);
    useEffect(() => { api.get("/programs").then(({ data }) => setPrograms(data)).catch(() => {}); }, []);

    if (!config) return null;

    return (
        <div data-testid="programs-page">
            <SeoHead pageKey="programs" />
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12">
                <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-4">{config.programs_page_kicker}</div>
                <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] max-w-4xl mb-6" data-testid="programs-title">
                    {config.programs_page_title}
                </h1>
                <p className="text-lg text-muted-foreground max-w-3xl">
                    {config.programs_page_intro}
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24" data-testid="programs-grid">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {programs.map((p, i) => (
                        <Link
                            to={`/programs/${p.slug}`}
                            key={p.id}
                            className={`group relative overflow-hidden rounded-sm border border-border bg-card hover:border-primary/60 transition-colors ${
                                i % 7 === 0 ? "sm:col-span-2" : ""
                            }`}
                            data-testid={`program-tile-${p.slug}`}
                        >
                            <div className={`${i % 7 === 0 ? "aspect-[16/9]" : "aspect-[4/3]"} overflow-hidden`}>
                                <AnimatedImage src={p.image_url} alt={p.title} className="w-full h-full" />
                            </div>
                            <div className="p-6">
                                <div className="flex items-center justify-between mb-3">
                                    <span className="text-xs uppercase tracking-[0.18em] text-primary">Thematic Area {String(i + 1).padStart(2, "0")}</span>
                                    <ArrowUpRight size={16} className="opacity-50 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                                </div>
                                <h3 className="font-display text-2xl mb-3 leading-tight group-hover:text-primary transition-colors">{p.title}</h3>
                                <p className="text-sm text-muted-foreground line-clamp-3">{p.summary}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
